<template>
    <div class="def-content">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DefContent',
    selector: '.def-content',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.def-content{
    font-weight: 500;
    :deep(h2){
        margin-bottom: 24px;
    }
    :deep(ul){
        margin: 24px 0;
        padding-left: 18px;
        li{
            list-style-type: disc;
            &:not(:last-child){
                margin-bottom: 16px;
            }
        }
    }
    :deep(a){
        display: inline-block;
        text-decoration: underline;
        text-underline-position: under;
        transition: .2s linear color;
        &:hover{
            color: var(--color-dark-grey);
        }
    }
    :deep( > *:last-child){
        margin-bottom: 0;
    }
}
</style>